import React, { useState } from "react"
import { Text, Flex, Box, Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react"
import ReactSlider from "react-slider"
import Icon from "@components/Icon/Icon"

const FilterSliderMobile: React.FC = (props: any) => {
  const [isOpen, setIsOpen] = useState(false)
  
  const defaultValue = props?.filterSliderProps?.reactSliderProps?.defaultValue || [0, 280];
  const initialValue = props?.filterSliderProps?.value?.[1] !== 0 ? props?.filterSliderProps?.value : defaultValue;
  
  // Initialize local state with valid numbers
  const [localValue, setLocalValue] = useState<[number, number]>([
    Number.isFinite(initialValue[0]) ? initialValue[0] : defaultValue[0],
    Number.isFinite(initialValue[1]) ? initialValue[1] : defaultValue[1]
  ]);

  // Update local state when props change
  React.useEffect(() => {
    if (props?.filterSliderProps?.value) {
      const min = Number.isFinite(props?.filterSliderProps?.value[0]) ? props?.filterSliderProps?.value[0] : defaultValue[0];
      const max = Number.isFinite(props?.filterSliderProps?.value[1]) && props?.filterSliderProps?.value[1] !== 0 ? props?.filterSliderProps?.value[1] : defaultValue[1];
      console.log(min, max);
      if (localValue[0] !== min || localValue[1] !== max) {
        setLocalValue([min, max]);
      }
    }
  }, [props?.filterSliderProps?.value, defaultValue, localValue])

  return (
    <Flex position="relative">
      <Accordion w="100%" allowToggle={true}>
        <AccordionItem w="100%">
          <AccordionButton w="100%" _hover={{ backgroundColor: `transparent` }}>
            <Flex w="100%" fontSize="15px" alignItems={"center"} onClick={() => setIsOpen(!isOpen)} cursor="pointer">
              <Text fontWeight={props.filterSliderProps.totalSelected ? "600" : "normal"}>{props.filter.name}</Text>
              <Box ml="auto" transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
                <Icon ml="10px" name="chevronDown" size="14px" color="black"></Icon>
              </Box>
            </Flex>
          </AccordionButton>
          <AccordionPanel pb={1} overflow={"auto"}>
            <Flex py={4} flexDirection={"column"}>
              <Flex justify="space-between" mb={2}>
                <Box>${localValue[0]}</Box>
                <Box>${localValue[1]}</Box>
              </Flex>
              <ReactSlider
                min={0}
                max={280}
                step={10}
                {...props?.filterSliderProps?.reactSliderProps}
                value={localValue}
                className="rs-price-slider"
                ariaLabel={["Lower thumb", "Upper thumb"]}
                ariaValuetext={state => `$${state.valueNow}`}
                renderThumb={props => <div {...props} />}
                onChange={(value: [number, number]) => {
                  setLocalValue(value);
                }}
                onAfterChange={(value: [number, number]) => {
                  props?.filterSliderProps?.handleChange(value);
                }}

              />
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}

export default FilterSliderMobile
